import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useEffect } from 'react';
import Utils from '../../utils';
import './PlainFilePreview.css';
import dompurify from 'dompurify';

var PlainFilePreview = function PlainFilePreview(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      content = _React$useState2[0],
      setContent = _React$useState2[1];

  var sanitizer = dompurify.sanitize;
  useEffect(function () {
    Utils.apiClients.files.getResourceToken(workspace, path).then(function (resourceToken) {
      Utils.apiClients.content.getPreview(workspace, path, resourceToken).then(function (content) {
        return setContent(content);
      });
    });
  }, [workspace, path]);
  return React.createElement("div", {
    className: "highlight",
    dangerouslySetInnerHTML: {
      __html: sanitizer(content)
    }
  });
};

export default PlainFilePreview;